import { render, staticRenderFns } from "./PrivacyLinks.vue?vue&type=template&id=5cd22808"
import script from "./PrivacyLinks.vue?vue&type=script&lang=js"
export * from "./PrivacyLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports